import React, {useCallback, useEffect, useState} from 'react';
import './App.css';
import {Layout1_Single} from "./screens/Layout1_Single";
import {useAppDispatch, useAppSelector} from "./app/hooks";
import {selectScreenMode, selectShowModal, setMode, setShowModal} from "./features/omikuji/omikujiSlice";
import {Screen1_Agreement} from "./screens/Screen1_Agreement";
import {Screen2_Top} from "./screens/Screen2_Top";
import {Screen3_TopModal} from "./screens/Screen3_TopModal";
import {Screen4_Direction} from "./screens/Screen4_Direction";
import {Screen5_Pray_wait10sec} from "./screens/Screen5_Pray_wait10sec";
import {Screen6_Record_wait3sec} from "./screens/Screen6_Record_wait3sec";
import {Screen7_Clap_record3sec} from "./screens/Screen7_Clap_record3sec";
import {Screen8_WaitOmikujiLoading} from "./screens/Screen8_WaitOmikujiLoading";
import {Screen9_Result} from "./screens/Screen9_Result";
import {Screen10_Error} from "./screens/Screen10_Error";
import {Modal} from "antd";
import {Helmet} from "react-helmet";
import md5 from "md5";


function App() {
    const mode = useAppSelector(selectScreenMode)
    const [kichimd5, setKichiMd5] = useState("")
    const kichiImage = useCallback((kichimd5: string) => {
        return `https://aiomikuji2023image.s3.ap-northeast-1.amazonaws.com/${kichimd5}.png`
    }, [kichimd5])
    useEffect(() => {
        const url = window.location.href
        if (url.includes("?r=")) {
            const kichimd5 = url.split("=")[1]
            setKichiMd5(kichimd5)
        }
    }, [window.location.href])
    return <Layout1_Single>
        <Helmet
            meta={[
                {name: 'twitter:card', content: 'summary'},
                {property: 'og:image', content: `${kichiImage(kichimd5)}`},
                {property: 'og:url', content: "https://ai-omikuji2023.elith.co.jp/"}
            ]}
        />
        {mode === "mode1_Agreement" && <Screen1_Agreement/>}
        {(mode === "mode2_Top" || mode === "mode3_TopModal") && <Screen2_Top/>}
        {mode === "mode4_Direction" && <Screen4_Direction/>}
        {mode === "mode5_Pray" && <Screen5_Pray_wait10sec/>}
        {mode === "mode6_Ready" && <Screen6_Record_wait3sec/>}
        {mode === "mode7_Clap" && <Screen7_Clap_record3sec/>}
        {mode === "mode8_Loading" && <Screen8_WaitOmikujiLoading/>}
        {mode === "mode9_Result" && <Screen9_Result/>}
        {mode === "mode10_Error" && <Screen10_Error/>}
    </Layout1_Single>

}

export default App;
